import React from 'react';
import { Helmet } from 'react-helmet-async';

interface PageSEOProps {
  title: string;
  description: string;
  path: string;
  image?: string;
  type?: 'website' | 'article' | 'product';
  schema?: object;
}

const PageSEO: React.FC<PageSEOProps> = ({
  title,
  description,
  path,
  image = 'https://firebasestorage.googleapis.com/v0/b/site-comprendre-les-ses-c5b6a.appspot.com/o/images%2Fphoto%20profil%20SES.jpeg?alt=media&token=b2a39978-10b6-4889-9a79-d50e6220dbf5',
  type = 'website',
  schema
}) => {
  const url = `https://cours-ses.fr${path}`;

  return (
    <Helmet>
      {/* Balises meta de base */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Comprendre les SES" />
      <meta property="og:locale" content="fr_FR" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Schema.org JSON-LD */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
};

export default PageSEO;